import type { IconSvgObject } from './types';

const ArrowRightToLineIcon: IconSvgObject = [
  ["path", { d: "M12 7L17 12L12 17M16 12L3 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 6V18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowRightToLineIcon;
